'use strict';

var MixinClass = function(mixin) {
    this.mixin = mixin;
};

MixinClass.prototype.getMixin = function() {
    return _.clone(this.mixin);
};

MixinClass.prototype.extend = function(obj) {
    return _.extend({}, this.mixin, obj);
};

MixinClass.prototype.deepExtend = function(obj) {
    return _.merge({}, this.mixin, obj);
};

module.exports = MixinClass;
